import { createStandardAction, createAsyncAction } from "typesafe-actions";
import { QuoteResponse } from "../../lib/model/QuoteResponse";
import { QuoteRequest } from "../../lib/model/QuoteRequest";
import { BookMultiOrder, BookPoint } from "./model/BookMultiOrder";
import { CreateOrderRequest } from "../../lib/model/CreateOrderRequest";
import { Order } from "../../lib/model/Order";
import { TourType } from "../../lib/model/TourType";

export const selectMultiType = createStandardAction(
  "multiBooking/UPDATE_TYPE"
).map((type: TourType) => ({
  payload: type
}));

export const updateOrder = createStandardAction(
  "multiBooking/UPDATE_ORDER"
).map((order: BookMultiOrder) => ({
  payload: order
}));

export const updateSinglePoint = createStandardAction(
  "multiBooking/UPDATE_SINGLE_POINT"
).map((point: BookPoint) => ({
  payload: point
}));

export const updateMultiPoints = createStandardAction(
  "multiBooking/UPDATE_MULTI_POINTS"
).map((pointIndex: number, point: BookPoint) => ({
  payload: { pointIndex, point }
}));

export const resetOrder = createStandardAction("multiBooking/RESET_ORDER")();

export const resetQuote = createStandardAction("multiBooking/RESET_QUOTE")();

export const addPoint = createStandardAction("multiBooking/ADD_POINT")();

export const deletePoint = createStandardAction(
  "multiBooking/DELETE_POINT"
).map((pointIndex: number) => ({
  payload: pointIndex
}));

export const fetchQuoteAsync = createAsyncAction(
  "multiBooking/FETCH_QUOTE_REQUEST",
  "multiBooking/FETCH_QUOTE_SUCCESS",
  "multiBooking/FETCH_QUOTE_FAILURE"
)<QuoteRequest, QuoteResponse, Error>();

export const createOrderAsync = createAsyncAction(
  "multiBooking/CREATE_ORDER_REQUEST",
  "multiBooking/CREATE_ORDER_SUCCESS",
  "multiBooking/CREATE_ORDER_FAILURE"
)<CreateOrderRequest, Order, Error>();
